"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadPlayer = exports.createOasisLoader = void 0;
var tslib_1 = require("tslib");
var VERSION_TEMPLATE = '[VERSION]';
var CONFIG_BASE_URL = '//config.player.p7s1.io/';
function isPlayerConfig(config) {
    return config.urls !== undefined;
}
function isBootstrapComponent(comp) {
    return typeof comp === 'object' && !!comp.init;
}
var isValidOasisLoader = function (oasisLoader) {
    if (oasisLoader && typeof oasisLoader.register === 'function') {
        var registry = oasisLoader.registry;
        return registry && typeof registry === 'object';
    }
    return false;
};
var createOasisLoader = function () {
    var registry = {};
    return {
        get registry() {
            return registry;
        },
        register: function (name, componentFactory) {
            registry[name] = componentFactory;
        },
    };
};
exports.createOasisLoader = createOasisLoader;
function loadPlayer(_a) {
    var _b;
    var config = _a.config, loadScript = _a.loadScript, playerPerformance = _a.playerPerformance, VERSION = _a.VERSION;
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var id, configId, oasisLoader, loadComponents, loadedConfig, publicUrls, mergedConfig, element, playerComponentName, urls, version, highestVersion, components, component, bootstrapComponent;
        var _c;
        var _this = this;
        return tslib_1.__generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    id = config.id;
                    configId = "config:".concat(id);
                    oasisLoader = (global.oasisLoader = isValidOasisLoader(global.oasisLoader)
                        ? global.oasisLoader
                        : (0, exports.createOasisLoader)());
                    loadComponents = function (componentUrls, highestVersion) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                        var names, urls, promises;
                        return tslib_1.__generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    names = Object.keys(componentUrls);
                                    urls = names.map(function (name) { return componentUrls[name]; });
                                    promises = urls.map(function (url) {
                                        return loadScript(highestVersion ? url.replace(VERSION_TEMPLATE, highestVersion) : url, {
                                            returnPromise: true,
                                            numRetries: 3,
                                        });
                                    });
                                    return [4 /*yield*/, Promise.all(promises)];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/, names.reduce(function (components, name) {
                                            components[name] = oasisLoader.registry[name]();
                                            return components;
                                        }, {})];
                            }
                        });
                    }); };
                    return [4 /*yield*/, loadComponents((_c = {},
                            _c[configId] = "".concat(CONFIG_BASE_URL).concat(id, ".js"),
                            _c))];
                case 1:
                    loadedConfig = (_d.sent())[configId];
                    playerPerformance.push({
                        name: 'configLoaded',
                        timestamp: Date.now(),
                    });
                    publicUrls = (_b = loadedConfig === null || loadedConfig === void 0 ? void 0 : loadedConfig.player) === null || _b === void 0 ? void 0 : _b.urls;
                    mergedConfig = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, loadedConfig), config), { 
                        // TODO Remove 'urls' & make refactoring of config in test-page after removing from json
                        urls: tslib_1.__assign(tslib_1.__assign({}, publicUrls), (isPlayerConfig(config) && config.urls)) });
                    element = mergedConfig.element, playerComponentName = mergedConfig.playerComponentName, urls = mergedConfig.urls, version = mergedConfig.version;
                    highestVersion = version && Number(version.split('.').join('')) > Number(VERSION.split('.').join(''))
                        ? version
                        : VERSION;
                    return [4 /*yield*/, loadComponents(urls, highestVersion)];
                case 2:
                    components = _d.sent();
                    playerPerformance.push({
                        name: 'componentsLoaded',
                        timestamp: Date.now(),
                    });
                    component = components[playerComponentName];
                    if (isBootstrapComponent(component)) {
                        bootstrapComponent = component;
                        delete components[playerComponentName];
                    }
                    else
                        throw new Error("Unable to load ".concat(playerComponentName));
                    return [2 /*return*/, new Promise(function (resolve, reject) {
                            bootstrapComponent.init([mergedConfig], components, function (error, bootstrap) {
                                if (error)
                                    reject(error);
                                bootstrap.create(element, function (error, playerApi) {
                                    if (!error && playerApi)
                                        resolve(playerApi);
                                    reject(error !== null && error !== void 0 ? error : new Error('Error while creating PlayerApi'));
                                });
                            }, {
                                playerPerformance: playerPerformance,
                            });
                        })];
            }
        });
    });
}
exports.loadPlayer = loadPlayer;
//# sourceMappingURL=load-player.js.map